import React from 'react';
import { motion } from 'framer-motion';
import { Section, staggerContainer, fadeIn } from './ui/Section';
import { Check, X } from 'lucide-react';
export function ForWhomSection() {
  return <Section data-id="element-145">
      <div className="grid md:grid-cols-2 gap-12 md:gap-24" data-id="element-146">
        {/* For You */}
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={staggerContainer} data-id="element-147">
          <h3 className="text-2xl font-bold text-slate-900 mb-8 flex items-center" data-id="element-148">
            <span className="bg-green-100 text-green-700 p-2 rounded-lg mr-3" data-id="element-149">
              <Check className="w-6 h-6" data-id="element-150" />
            </span>
            Esto es para ti si...
          </h3>
          <ul className="space-y-6" data-id="element-151">
            {['Vives en USA y entiendes pero no respondes rápido', "Te frustra sonar 'demasiado formal' o 'robot'", 'Quieres una solución práctica, guiada, sin perderte en teoría', 'Te interesa tener frases listas para: pedir, confirmar, corregir, cerrar'].map((item, idx) => <motion.li key={idx} variants={fadeIn} className="flex items-start" data-id="element-152">
                <Check className="w-5 h-5 text-green-600 mr-3 mt-1 flex-shrink-0" data-id="element-153" />
                <span className="text-slate-700 text-lg" data-id="element-154">{item}</span>
              </motion.li>)}
          </ul>
        </motion.div>

        {/* Not For You */}
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={staggerContainer} className="bg-slate-50 p-8 rounded-3xl border border-slate-100" data-id="element-155">
          <h3 className="text-2xl font-bold text-slate-900 mb-8 flex items-center" data-id="element-156">
            <span className="bg-red-100 text-red-700 p-2 rounded-lg mr-3" data-id="element-157">
              <X className="w-6 h-6" data-id="element-158" />
            </span>
            Esto NO es para ti si...
          </h3>
          <ul className="space-y-6" data-id="element-159">
            {['Quieres un curso largo con tareas eternas', 'Buscas gramática pesada o preparación académica', "Quieres 'pronunciar perfecto' antes de hablar"].map((item, idx) => <motion.li key={idx} variants={fadeIn} className="flex items-start" data-id="element-160">
                <X className="w-5 h-5 text-red-500 mr-3 mt-1 flex-shrink-0" data-id="element-161" />
                <span className="text-slate-600 text-lg" data-id="element-162">{item}</span>
              </motion.li>)}
          </ul>
        </motion.div>
      </div>
    </Section>;
}